import Image from 'next/image'
import type { CollectionProduct } from '@lib/types'
import PriceDisplay from './PriceDisplay'

interface ProductCardSneakPeakProps {
	product: CollectionProduct
	className?: string
}

const getPriceToDisplay = (product: CollectionProduct) => {
	const compare = product.compareAtPrice
	if (compare && parseFloat(compare.amount) > 0) {
		return compare
	}
	return null
}

export default function ProductCardSneakPeak({
	product,
	className = ''
}: ProductCardSneakPeakProps) {
	const priceToDisplay = getPriceToDisplay(product)

	return (
		<div className={`flex flex-col items-center w-full ${className}`}>
			{/* Fixed-height badge row — always present so all images align at the same Y */}
			<div className="h-6 flex items-center justify-center mb-1">
				{priceToDisplay && <PriceDisplay price={priceToDisplay} className="mb-0" />}
			</div>
			{product.images[0] && (
				<div className="relative w-full aspect-square mb-3">
					<Image
						src={product.images[0].url}
						alt={product.images[0].altText || product.name}
						fill
						className="object-contain"
						sizes="(max-width: 640px) 90vw, (max-width: 768px) 33vw, (max-width: 1024px) 25vw, 200px"
					/>
				</div>
			)}
			<div className="text-sm font-semibold text-center text-bbx-style">{product.vendor}</div>
			<div className="text-xs font-normal text-center text-bbx-style/55 leading-snug line-clamp-2 mt-0.5">{product.name}</div>
		</div>
	)
}
